import type { AxiosResponse } from "axios";
import type { AttemptAudioPlaybackDownloadResponse } from "~/types/admin/assessment";

const getNumericHeader = (
  response: AxiosResponse<Blob>,
  headerName: string,
): number | null => {
  const rawValue = response.headers[headerName];
  const value = Array.isArray(rawValue) ? rawValue[0] : rawValue;
  const parsedValue = Number(value);

  return Number.isFinite(parsedValue) ? parsedValue : null;
};

export const buildAttemptAudioPlaybackDownloadResponse = (
  response: AxiosResponse<Blob>,
): AttemptAudioPlaybackDownloadResponse => ({
  audioBlob: response.data,
  playCount: getNumericHeader(response, "x-assessment-audio-play-count"),
  remainingPlays: getNumericHeader(
    response,
    "x-assessment-audio-remaining-plays",
  ),
});
